export default {
  closeAlternativeText: {
    id: 'skinny_banner_close',
    defaultMessage: 'Close banner',
  },
}
